import { route } from '@md/routing'
import { accessPermission } from '@md/users/permissions'
import { TYPES } from '@md/users/constances'

const List = () => import('./views/List')

export const EMES_SUBSCRIBERS_ROLES = [
  TYPES.ADMINISTRATOR,
  TYPES.MANAGER,
]

export function createRoutes(options) {
  return [
    route('list/', List, 'profile:emes-subscribers:list', {
      meta: { accessConfig: accessPermission(EMES_SUBSCRIBERS_ROLES, options) },
    }),
  ]
}
